import moment from 'moment'
import { monthsDifference } from '../utils'

export enum OriginSystem {
  VTI_GIS = "VTI_GIS",
  HEYCAR_GIS = "HEYCAR_GIS",
  HEYCAR = "HEYCAR",
  HEYCAR_DEALER = "HEYCAR_DEALER"
}

export enum DeliveryType {
  HOME_DELIVERY = "HOME_DELIVERY",
  DEALERSHOP = "DEALERSHOP"
}

export const isVtiBOP = (originSystem: string) => {
  return [OriginSystem.VTI_GIS].includes(originSystem as OriginSystem)
}

export const isHeycarBOP = (originSystem: string) => {
  return [OriginSystem.HEYCAR_GIS, OriginSystem.HEYCAR].includes(originSystem as OriginSystem)
}

export const isHeycarDealer = (originSystem: string) => {
  return [OriginSystem.HEYCAR_DEALER].includes(originSystem as OriginSystem)
}

export const isOriginHeycar = (originSystem: string) => {
  return originSystem?.includes('HEYCAR')
}

export const isHomeDelivery = (vehicleData: any) => {
  return vehicleData?.delivery?.deliveryType === DeliveryType.HOME_DELIVERY
}

export const isDealerShop = (vehicleData: any) => {
  return vehicleData?.delivery?.deliveryType === DeliveryType.DEALERSHOP
}

export const isENVKVNew = (vehicleData: any) => {
  return (!vehicleData?.isUsed && vehicleData?.odometer < 1000)
  || (monthsDifference(vehicleData?.initialRegistrationDate, moment.now()) < 8);
}